import { render, staticRenderFns } from "./ImageGalleryBlock.vue?vue&type=template&id=06824eb7&scoped=true"
import script from "./ImageGalleryBlock.vue?vue&type=script&lang=js"
export * from "./ImageGalleryBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06824eb7",
  null
  
)

export default component.exports